// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-buttons button {
  font-size: .875rem;
}
.group-buttons {
    display: flex;
    justify-content: flex-end;
}
.group-container-title {
    margin: 0;
    font-weight: 600;
    display: inline-block;
    line-height: 1.3;
    min-height: 48px;
    padding: 12px 48px 12px 0;
    vertical-align: top;
    font-size: 1.25em;
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/chart-viewer-filter/group-container/group-container.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".group-buttons button {\r\n  font-size: .875rem;\r\n}\r\n.group-buttons {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n.group-container-title {\r\n    margin: 0;\r\n    font-weight: 600;\r\n    display: inline-block;\r\n    line-height: 1.3;\r\n    min-height: 48px;\r\n    padding: 12px 48px 12px 0;\r\n    vertical-align: top;\r\n    font-size: 1.25em;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
